import { Link } from 'react-router-dom';

export default function BrandSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-1/2">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5 leading-tight">
              Why Thousands of Shoppers Trust Hipobuy Spreadsheets
            </h2>
            <p className="text-base text-foreground-700 leading-relaxed mb-4">
              A Hipobuy spreadsheet is more than just a list of links — it is a complete product research system built by experienced shoppers who have spent countless hours verifying sellers, comparing prices, and collecting QC photos. Every entry in the spreadsheet represents a product that has been vetted for quality, value, and reliability.
            </p>
            <p className="text-base text-foreground-700 leading-relaxed mb-6">
              Whether you are hunting for the latest sneakers, building a new wardrobe, or looking for unique accessories, the organized format of a Hipobuy spreadsheet lets you compare dozens of products side by side, filter by price, sort by rating, and make confident purchasing decisions in a fraction of the time it would take through traditional browsing.
            </p>
            <Link
              to="/hipobuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-50 rounded-full text-sm font-semibold text-primary-600 hover:bg-primary-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Read the Complete Guide
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>

            <div className="mt-10 flex items-center gap-12">
              <div>
                <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">14+</p>
                <p className="text-xs text-foreground-500 mt-1">Product Categories</p>
              </div>
              <div>
                <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">200K+</p>
                <p className="text-xs text-foreground-500 mt-1">Happy Shoppers</p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <div className="relative rounded-[40px] overflow-hidden bg-background-200 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20scene%20with%20premium%20sneakers%20a%20leather%20bag%20and%20a%20soft%20cashmere%20scarf%20artfully%20arranged%20on%20a%20warm%20stone%20surface%20bathed%20in%20gentle%20natural%20window%20light%2C%20editorial%20lifestyle%20aesthetic%2C%20minimal%20composition%2C%20warm%20earthy%20tones%2C%20organic%20styling&width=900&height=675&seq=brand-scene-v2-2026&orientation=landscape"
                alt="Product scene"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-4 left-4">
                <span className="inline-block px-4 py-2 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-semibold text-foreground-700 whitespace-nowrap">
                  Curated Collection
                </span>
              </div>
              <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
              <div className="absolute bottom-6 left-6">
                <p className="text-sm font-semibold text-background-50">Verified Products</p>
                <p className="text-xs text-background-200 mt-1">Updated weekly with new finds</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}